module.exports = __webpack_public_path__ + "img/sidebar-button.5ace631.webp";